var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { useStableOkapiKy } from "./useStableOkapiKy";
import { NaturalPersonStatusEnum } from "../types/Api";
import { useModal } from "../utils/useModal";
import { useApiAction } from "../utils/useApiAction";
import { useDetailParam } from "../utils/detailParam";
import { usePermissions } from "./usePermissions";
import { useGetCurrentUser } from "../utils/useCurrentUser";
import { deleteNaturalPerson, fetchNaturalPersonById, } from "../api/naturalPersonService";
import { buildPersonDeleteErrorMessage, parsePersonDeleteError, } from "../utils/personDeleteErrors";
export var useNaturalPersonActions = function () {
    var ky = useStableOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useModal(), isOpen = _a.isOpen, message = _a.message, action = _a.action, openModal = _a.openModal, closeModal = _a.closeModal;
    var performAction = useApiAction().performAction;
    var _b = useState(false), errorOpen = _b[0], setErrorOpen = _b[1];
    var _c = useState(""), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useDetailParam(), detailId = _d.detailId, updateDetailParam = _d.updateDetailParam;
    var _e = usePermissions(), canEditNaturalPerson = _e.canEditNaturalPerson, canDeleteNaturalPerson = _e.canDeleteNaturalPerson, isSuperUser = _e.isSuperUser, isPublisher = _e.isPublisher;
    var currentUser = useGetCurrentUser().data;
    var _f = useState(null), selectedNaturalPerson = _f[0], setSelectedNaturalPerson = _f[1];
    useEffect(function () {
        var fetchItem = function () { return __awaiter(void 0, void 0, void 0, function () {
            var item, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(detailId && (selectedNaturalPerson === null || selectedNaturalPerson === void 0 ? void 0 : selectedNaturalPerson.id) !== detailId)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchNaturalPersonById(ky, detailId)];
                    case 2:
                        item = _a.sent();
                        if (item) {
                            setSelectedNaturalPerson(item);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setSelectedNaturalPerson(null);
                        updateDetailParam(null);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if (!detailId) {
                            setSelectedNaturalPerson(null);
                        }
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchItem();
    }, [ky, selectedNaturalPerson, detailId, updateDetailParam]);
    var handleRowClick = function (item) {
        updateDetailParam(item.id);
        setSelectedNaturalPerson(item);
    };
    var handleDelete = function (itemId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2, deleteError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, performAction({
                            apiCall: function () { return deleteNaturalPerson(ky, itemId); },
                            queryKey: "natural-persons",
                            errorMsg: formatMessage({
                                id: "ui-br-agency.natural-person.error.delete",
                            }),
                            onSuccess: function () {
                                setSelectedNaturalPerson(null);
                                updateDetailParam(null);
                                closeModal();
                            },
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    return [4 /*yield*/, parsePersonDeleteError(error_2)];
                case 3:
                    deleteError = _a.sent();
                    setErrorMessage(buildPersonDeleteErrorMessage(formatMessage, "natural-person", deleteError));
                    setErrorOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openDeleteConfirm = function (item) {
        var displayName = item.firstName && item.lastName
            ? "".concat(item.firstName, " ").concat(item.lastName)
            : item.sourceId;
        openModal(formatMessage({ id: "ui-br-agency.natural-person.delete.confirm" }, { name: displayName }), function () { return handleDelete(item.id); });
    };
    var handleCloseDetail = function () {
        setSelectedNaturalPerson(null);
        updateDetailParam(null);
    };
    var canEditSelectedPerson = useMemo(function () {
        var _a, _b;
        if (!selectedNaturalPerson)
            return false;
        var hasProposalStatus = selectedNaturalPerson.status === NaturalPersonStatusEnum.PROPOSAL;
        var isUserProposer = isSuperUser ||
            (((_a = selectedNaturalPerson.proposer) === null || _a === void 0 ? void 0 : _a.sourceId) &&
                currentUser &&
                ((_b = currentUser.activeOrganization) === null || _b === void 0 ? void 0 : _b.sourceId) ===
                    selectedNaturalPerson.proposer.sourceId);
        return canEditNaturalPerson && hasProposalStatus && isUserProposer;
    }, [selectedNaturalPerson, canEditNaturalPerson, isSuperUser, currentUser]);
    var canReportChange = useMemo(function () {
        if (!selectedNaturalPerson)
            return false;
        return (isPublisher &&
            (selectedNaturalPerson === null || selectedNaturalPerson === void 0 ? void 0 : selectedNaturalPerson.status) === NaturalPersonStatusEnum.CONFIRMED);
    }, [selectedNaturalPerson, isPublisher]);
    var canDeleteSelectedPerson = useMemo(function () {
        var _a, _b;
        if (!selectedNaturalPerson)
            return false;
        var hasProposalStatus = selectedNaturalPerson.status === NaturalPersonStatusEnum.PROPOSAL;
        var isUserProposer = isSuperUser ||
            (((_a = selectedNaturalPerson.proposer) === null || _a === void 0 ? void 0 : _a.sourceId) &&
                currentUser &&
                ((_b = currentUser.activeOrganization) === null || _b === void 0 ? void 0 : _b.sourceId) ===
                    selectedNaturalPerson.proposer.sourceId);
        return canDeleteNaturalPerson && hasProposalStatus && isUserProposer;
    }, [selectedNaturalPerson, canDeleteNaturalPerson, isSuperUser, currentUser]);
    var closeError = function () { return setErrorOpen(false); };
    return {
        selectedNaturalPerson: selectedNaturalPerson,
        /** Replaces the shown person, e.g. after an NK authority link action (DB-635). */
        setSelectedNaturalPerson: setSelectedNaturalPerson,
        isModalOpen: isOpen,
        modalMessage: message,
        modalAction: action,
        handleRowClick: handleRowClick,
        openDeleteConfirm: openDeleteConfirm,
        handleCloseDetail: handleCloseDetail,
        closeModal: closeModal,
        canEditSelectedPerson: canEditSelectedPerson,
        canReportChange: canReportChange,
        canDeleteSelectedPerson: canDeleteSelectedPerson,
        errorOpen: errorOpen,
        errorMessage: errorMessage,
        closeError: closeError,
    };
};
